import { ChangeDetectionStrategy, Component, effect, inject, input, model, untracked } from '@angular/core';
import { ClarityModule } from '@clr/angular';
import { WindowMediaQueryDirective } from 'src/app/directives/window-media-query.directive';
import { ExpandedAnsicht, ExpandedStateStore } from './expanded.store';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';

@Component({
  selector: 'app-expand-buttons',
  templateUrl: './expand-buttons.component.html',
  styleUrl: './expand-buttons.component.scss',
  imports: [ClarityModule, WindowMediaQueryDirective, MrTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandButtonsComponent {
  protected readonly expandedStore = inject(ExpandedStateStore);
  public readonly ansichtMode = model.required<ExpandedAnsicht>();
  public readonly hideBothIfWidthLess = input(0);
  public readonly hideExpandIfWidthLess = input(0);
  public readonly hideSplitIfWidthLess = input(0);

  constructor() {
    effect(() => {
      const explicitMode = this.ansichtMode();
      untracked(() => this.expandedStore.explicit(explicitMode));
    });

    effect(() => {
      const currentMode = this.expandedStore.ansicht();
      untracked(() => this.ansichtMode.set(currentMode));
    });
  }
}
